<script lang="ts">
  import Calendar from 'svelte-calendar';
  import { navigate } from 'svelte-routing';
  import { TimePickerModal } from 'svelte-time-picker';
  import { fade } from 'svelte/transition';
  import { saveSessions } from '../../api';
  import type { ISession } from '../../api/entities';
  import { notifyError, notifySuccess } from '../../stores/notifications';
  import { setTitle } from '../../stores/titles';
  import { DaysOfWeek, formatDate, MonthsOfYear, QuickSessions } from '../../utils';

	const mondayOfThisWeek = () => {
    const today = new Date();
    return new Date(today.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)));
  }

  export let session: ISession = { name: '', nbPlaces: 15, date: new Date() };

  let startDateForTimePicker = new Date();

  const changeTime = ({ detail } : any) => {
    session.date.setHours(detail.getHours(), detail.getMinutes());
    session.date = new Date(session.date);
  };

  let changeDay = (e : any) => {
    const { detail: { date: newDate } } = e;
    session.date = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), session.date.getHours(), session.date.getMinutes());
  };

  let timeModalIsOpen = false;
  const openTimeModal = () => {
    timeModalIsOpen = true;
    startDateForTimePicker = new Date(session.date);
  };

  const closeTimeModal = () => {
    timeModalIsOpen = false;
  };

  const cancelTimeModal = () => {
    timeModalIsOpen = false;
    session.date = new Date(startDateForTimePicker);
  };

  const validate = async () => {
    try {
      await saveSessions([session]);
      navigate('/admin');
      notifySuccess('Nouvelle session enregistrée !!');
    }
    catch {
      notifyError('Oups, une erreur est survenue...');
    }
  };

  const setQuickSession = (quickSession) => {
    session.name = quickSession.name;
    session.nbPlaces = quickSession.nbPlaces;
    session.date = new Date(new Date(mondayOfThisWeek().setDate(mondayOfThisWeek().getDate() + quickSession.day)).setHours(quickSession.hour, quickSession.minutes))
    session.open = true;
  };

  setTitle('Création de session');
</script>


<style lang="scss">
  @import "../../styles/bulma.override";

  :global(.button.toto) {
    background: $info;
  }

  .time-modal {
    :global(.modal-background) {
      background: transparent;
    }
  }
</style>

<div class="columns is-centered mt-4">
  <div class="column is-two-thirds-tablet">
    <div class="field is-horizontal mb-6">
      <div class="field-label is-normal">
        <label for="name">Remplissage rapide :</label>
      </div>
      <div class="field-body">
        <div class="field buttons">
          {#each QuickSessions as quickSession}
            <button class="button is-small" on:click={() => setQuickSession(quickSession)}>
              {quickSession.name}
            </button>
          {/each}
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="name">Nom</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="text" maxlength="40" bind:value={session.name}>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="description">Description</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="text" bind:value={session.description}>
          </div>
        </div>
      </div>
    </div>
  
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="nbPlaces">Nombre de places</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="number" bind:value={session.nbPlaces}>
          </div>
          <p class="help has-text-left">Mettre -1 pour un nombre de places illimité</p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="nbPlaces">Inscriptions ouvertes</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <label class="checkbox">
              <input class="checkbox" type="checkbox" bind:checked={session.open}>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="horaire">Horaire</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control has-text-left">
            <Calendar
              start={new Date()}
              on:dateSelected={changeDay}
              format={(d) => formatDate(d)}
              daysOfWeek={DaysOfWeek}
              monthsOfYear={MonthsOfYear}
              weekStart={1}
            >
              <button class='button is-primary is-outlined'>
                {formatDate(session.date)}
              </button>
            </Calendar>

            <button class='button is-primary is-outlined' on:click={openTimeModal}>
              {formatDate(session.date, { withDate: false, withTime: true })}
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      class="button is-primary is-medium"
      on:click={validate}
      disabled={!session.name?.length}
    >
      Valider
    </button>
    <button
      class="button is-white is-medium"
      on:click={() => navigate('/admin')}
    >
      Retour
    </button>
  </div>
</div>



{#if timeModalIsOpen}

  <div class="time-modal" transition:fade={{ duration: 300 }}>
    <TimePickerModal
      options={{ is24h: true, hasButtons: true }}
      date={new Date(startDateForTimePicker)}
      on:change={changeTime}
      on:close={closeTimeModal}
      on:cancel={cancelTimeModal}
    />
  </div>
{/if}

